import styled from 'styled-components';

export const StyledLoading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 85px);
  width: 100%;
`;
